import styled from 'styled-components';

export const FlexLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
`;

export const FlexWrap = styled.div`
  display: flex;
  flex-flow: wrap column;
`;
